/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_OverviewInputs */

const en_directory_detail_section_overview = /** @type {(inputs: Directory_Detail_Section_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const zh_directory_detail_section_overview = /** @type {(inputs: Directory_Detail_Section_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Directory_Detail_Section_OverviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_overview = /** @type {((inputs?: Directory_Detail_Section_OverviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_OverviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_overview(inputs)
	return zh_directory_detail_section_overview(inputs)
});
export { directory_detail_section_overview as "directory.detail.section.overview" }